import { GlobalAxios } from "../axios/axios-config";
import {
  ISalesContractHcpInclusionRule,
  ISalesContractHcpInclusionRulePayload,
} from "../models/sales-contract-hcp-inclusion-rule";
import { IServiceUpdateParam } from "../utils/interfaces";

const serviceURL =
  process.env.REACT_APP_MAIN + "/api/v1/SalesContractHcpInclusionRule";

export const createSalesContractHcpInclusionRule = (
  payload: ISalesContractHcpInclusionRulePayload
) => {
  return GlobalAxios.post(serviceURL, payload);
};

export const updateSalesContractHcpInclusionRule = ({
  id,
  item,
}: IServiceUpdateParam<ISalesContractHcpInclusionRulePayload>) => {
  return GlobalAxios.put(`${serviceURL}/${id}`, item);
};

export const findSalesContractHcpInclusionRuleById = (id: string) => {
  return GlobalAxios.get<ISalesContractHcpInclusionRule>(`${serviceURL}/${id}`);
};
